"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleOptionsInput = void 0;
const React = require("react");
const standardizeOptions_1 = require("../../../../helpers/standardizeOptions");
const TextInput_1 = require("../TextInput");
const isValueInOptions_1 = require("../../../../helpers/isValueInOptions");
const BaseInput_1 = require("../BaseInput");
class SingleOptionsInput extends BaseInput_1.BaseInput {
    constructor(props) {
        super(props);
        // Sets the values
        this.setValue = (evt) => {
            const value = evt.target.value
                ? this.state.formattedOptions[parseInt(evt.target.value)].value
                : undefined;
            this.setState({ value: value });
            super.onInputChange(value);
        };
        this.state = Object.assign(Object.assign({}, this.state), { value: props.value, formattedOptions: this.getFormattedOptions(this.props.options) });
    }
    getFormattedOptions(options) {
        const placeholder = this.props.placeholder || "Please Select...";
        const formattedOptions = (0, standardizeOptions_1.standardizeOptions)(options, this.props.autoOrder).slice();
        const placeholderIndex = this.getPlaceholderIndex(options);
        /**
         * This logic adds the placeholder to the options array.
         * This can be the start, finish, or a defined index through the placeholder index prop.
         */
        formattedOptions.splice(placeholderIndex, 0, {
            value: "",
            label: placeholder
        });
        return formattedOptions;
    }
    getPlaceholderIndex(options) {
        let placeholderIndex = 0;
        if (this.props.placeholderIndex === "TOP") {
            placeholderIndex = 0;
        }
        else if (this.props.placeholderIndex === "BOTTOM") {
            placeholderIndex = options.length;
        }
        else if (this.props.placeholderIndex) {
            placeholderIndex = this.props.placeholderIndex;
        }
        return placeholderIndex;
    }
    componentDidUpdate(previousProps, previousState) {
        // options have changed, reformat and save.
        if (previousProps.options !== this.props.options) {
            this.setState({
                formattedOptions: this.getFormattedOptions(this.props.options)
            });
        }
        // suggestion for this input has change, reformat and save.
        if (previousState.suggestion !== this.state.suggestion) {
            if (!this.state.suggestion || !this.state.suggestion.data) {
                return;
            }
            this.setState({
                formattedOptions: this.getFormattedOptions(this.state.suggestion.data)
            });
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ value: nextProps.value });
    }
    render() {
        // wait for the options to be formatted
        if (!this.state.formattedOptions) {
            return;
        }
        const selectedIndex = this.state.formattedOptions
            .map((option, index) => {
            return option.value === this.state.value ? "" + index : false;
        })
            .filter((n) => n)[0];
        if (Array.isArray(this.props.value)) {
            return (React.createElement(TextInput_1.TextInput, { onInputChange: () => { }, disabled: true, value: this.state.value }));
        }
        if (!(0, isValueInOptions_1.isValueInOptions)(this.state.formattedOptions, this.props.value)) {
            return (React.createElement(TextInput_1.TextInput, { onInputChange: () => { }, disabled: true, value: this.state.value }));
        }
        if (this.state.fetchingSuggestion) {
            return (React.createElement("select", { disabled: true },
                React.createElement("option", null, "Loading...")));
        }
        return (React.createElement("select", { "data-test": "input", onChange: this.setValue, value: selectedIndex || "", disabled: this.props.disabled }, this.state.formattedOptions.map((v, i) => {
            return (React.createElement("option", { key: v.label, value: i, "data-test": `option-${v.value}`, "data-value": JSON.stringify(v.value) }, v.label));
        })));
    }
}
exports.SingleOptionsInput = SingleOptionsInput;
//# sourceMappingURL=index.js.map